// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3n8FG","title":"InfoRow_title__Vm6tA"};